import { useState, useEffect, useRef } from "react";
import {
  startTimer as startTimerService,
  endTimer as endTimerService,
} from "../../lib/services/stencilWeekService";
import { startTimer, stopTimer, resetTimer } from "../../lib/utils/time";

const StepButton = ({ 
    selectedMode, 
    stencilWeek, 
    volunteerName, 
    setStep,
    setTime,
    setStencilWeek,
    navigate
 }) => {
  // states for modes:
  const [val, setVal] = useState(0);
  const [mode, setMode] = useState(null);

  // timer state( for UI)
  const [running, setRunning] = useState(false);
  const tickRef = useRef(null);
  const startTs = useRef(null);

  // clean up interval on unmount
  useEffect(() => {
    return () => tickRef.current && clearInterval(tickRef.current);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      //  Don't do anything if stencilWeek or stencilData isn't ready yet
      if (!stencilWeek) return;

      if (selectedMode === "tracing") {
        if (stencilWeek.trace_start_time === null) setRunning(false);
        else 
            startTimer(
                running, 
                stencilWeek, 
                startTs, 
                setRunning, 
                setTime, 
                tickRef, 
                2
            );
      }

      if (selectedMode === "carving") {
        if (stencilWeek.carve_start_time === null) setRunning(false);
        else 
            startTimer(
                running, 
                stencilWeek, 
                startTs, 
                setRunning, 
                setTime, 
                tickRef, 
                3
            );
      }
    };

    fetchData();
  }, [selectedMode, stencilWeek]);

  useEffect(() => {
    if (selectedMode === "tracing") {
      setVal(2);
      setMode("traced");
    } else if (selectedMode === "carving") {
      setVal(3);
      setMode("carved");
    }
  }, []);

  return (
    <>
      <button
        className="vol-btn primary"
        disabled={stencilWeek[mode] >= 1}
        onClick={async () => {
          // Display this to UI
          startTimer(
            running,
            stencilWeek,
            startTs,
            setRunning,
            setTime,
            tickRef,
            val
        );

          // Update backend status: Tracing = 2 (in-progress)
          try {
            const res = await startTimerService(
              stencilWeek.week_num,
              stencilWeek.stencil_id,
              volunteerName,
              val
            );

            if (res && res.data) {
              setStencilWeek(res.data);
            }

            if (!res.ok && res.status === 409) {
              alert("This stencil week is already in progress or completed.");
            }
          } catch (error) {
            console.error("Error starting timer:", error);
            alert("Failed to start timer. Please try again.");
          }
        }}
      >
        Start
      </button>
      <button
        className="vol-btn success"
        disabled={stencilWeek[mode] === 0 || stencilWeek[mode] > 1}
        onClick={async () => {
          // Display this to UI
          stopTimer(
            running,
            tickRef,
            startTs,
            setTime,
            setRunning
          );
          // Update backend status: Tracing complete
          try {
            await endTimerService(
              stencilWeek.week_num,
              stencilWeek.stencil_id,
              val
            );
            navigate("/volunteer/complete");
          } catch (error) {
            console.error("Error ending timer:", error);
            alert("Failed to end timer. Please try again.");
          }
        }}
      >
        Done
      </button>
      <button
        className="vol-btn ghost"
        onClick={() => {
          resetTimer(
            setTime,
            startTs,
            tickRef,
            setRunning
          );
          setStep("mode");
        }}
      >
        Back
      </button>
    </>
  );
};

export default StepButton;
